export const HeaderList = [
    {
        id: 0,
        name: 'home',
        route: '/'
    },
    {
        id: 1,
        name: 'shop now',
        route: '/shop'
    },
    {
        id: 2,
        name: 'benefits',
        route: 'Benefits'
    },
    {
        id: 3,
        name: 'faq',
        route: 'Faq'
    },
    {
        id: 4,
        name: 'privacy policy',
        route: '/privacy-policy'
    },
    {
        id: 5,
        name: 'about us',
        route: 'AboutUs'
    }
]